<template>
  <section class="trust">
    <div class="trust__glow trust__glow--orange" aria-hidden="true"></div>
    <div class="trust__glow trust__glow--blue" aria-hidden="true"></div>

    <div class="trust__container">
      <div class="trust__head reveal">
        <h2 class="trust__title">{{ $t('home_page.cima_agree[4]') }}</h2>
        <span class="trust__bar"></span>
      </div>

      <div class="trust__grid">
        <div class="trust__card reveal">
          <div class="trust__stars">
            <i class="fas fa-star" v-for="s in 5" :key="s"></i>
          </div>
          <p class="trust__score">4,6<span>/5</span></p>
          <p class="trust__note">
            <strong>{{ $t('home_page.cima_agree[5]') }}</strong> {{ $t('home_page.cima_agree[6]') }}<br />
            {{ $t('home_page.cima_agree[7]') }}
          </p>
          <p class="trust__detail">{{ $t('home_page.cima_agree[8]') }}</p>
        </div>

        <div class="trust__card trust__card--accent reveal">
          <span class="trust__shield"><i class="fas fa-award"></i></span>
          <p class="trust__badge">{{ $t('home_page.cima_agree[10]') }}</p>
          <p class="trust__note">
            {{ $t('home_page.cima_agree[9]') }} <strong>{{ $t('home_page.cima_agree[10]') }}</strong>
          </p>
          <p class="trust__detail">{{ $t('home_page.cima_agree[11]') }}</p>
        </div>
      </div>

<!--      <div class="trust__banner reveal">
        <img :src="cimaBanner" alt="Agrément CIMA" loading="lazy" />
      </div>-->
    </div>
  </section>
</template>

<script>
export default {
  name: 'cima_section',
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),
  computed: {
    cimaBanner() {
      return require('../../../assets/img/home/new_home/start_cima.png');
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.trust {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #FFFBF6 0%, #fff 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.4;
    pointer-events: none;

    &--orange {
      width: 460px;
      height: 460px;
      background: rgba(255, 164, 9, 0.26);
      top: -160px;
      right: -140px;
    }

    &--blue {
      width: 440px;
      height: 440px;
      background: rgba(91, 148, 188, 0.26);
      bottom: -160px;
      left: -140px;
    }
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 52px;
  }

  &__title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 18px;
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }

  &__card {
    position: relative;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 24px;
    padding: 40px 34px;
    box-shadow: 0 18px 44px rgba(43, 43, 43, 0.07);
    text-align: center;
    overflow: hidden;
    transition: transform 0.35s cubic-bezier(0.22, 0.61, 0.36, 1),
      box-shadow 0.35s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 30px 60px rgba(43, 43, 43, 0.12);
    }

    &--accent {
      background: linear-gradient(140deg, #5B94BC 0%, #3d7ba6 100%);
      border-color: transparent;

      .trust__note,
      .trust__detail {
        color: rgba(255, 255, 255, 0.92);

        strong {
          color: #fff;
        }
      }

      .trust__badge {
        background: rgba(255, 255, 255, 0.16);
        color: #fff;
      }
    }
  }

  &__stars {
    display: flex;
    justify-content: center;
    gap: 4px;
    color: #ffa409;
    margin-bottom: 14px;

    i {
      font-size: 24px;
    }
  }

  &__score {
    font-size: 56px;
    font-weight: 800;
    line-height: 1;
    color: #2b2b2b;
    margin: 0 0 12px;

    span {
      font-size: 26px;
      font-weight: 700;
      color: #898d8f;
    }
  }

  &__note {
    margin: 0;
    font-size: 16px;
    line-height: 1.6;
    color: #59595b;

    strong {
      color: #2b2b2b;
    }
  }

  &__detail {
    margin: 14px 0 0;
    font-size: 14px;
    line-height: 1.7;
    color: #898d8f;
  }

  &__shield {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 68px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    margin-bottom: 16px;

    i {
      font-size: 34px;
    }
  }

  &__badge {
    display: inline-block;
    background: rgba(255, 164, 9, 0.16);
    color: #b06d00;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 7px 18px;
    border-radius: 999px;
    margin: 0 0 14px;
  }

  &__banner {
    margin-top: 44px;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 22px;
    box-shadow: 0 16px 40px rgba(43, 43, 43, 0.08);
    padding: 24px;
    display: flex;
    justify-content: center;

    img {
      max-height: 90px;
      width: auto;
      max-width: 100%;
      object-fit: contain;
    }
  }
}

@media (max-width: 991px) {
  .trust {
    padding: 72px 24px;

    &__grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    &__title {
      font-size: 32px;
    }
  }
}

@media (max-width: 600px) {
  .trust {
    padding: 56px 20px;

    &__card {
      padding: 32px 22px;
    }

    &__score {
      font-size: 46px;
    }
  }
}

</style>
